export class ProjectGeneralInfo {
    constructor(public projectId: string, public projectName: string, public projectTypeId: [], public archiveStatusId: string,
        public estimatedCost: string, public notes: string, public eeaNo: string, public location: string, public cityTown: string,
        public thresholds: string, public addressWatershed: string, public projectType: string, public latitude: string,
        public longitude: string, public archiveStatus: string, public agencyActions: string, public rowVersion: string) { }
}
